export const resources = [
  {
    title: "Video Tutorials",
    description: "Watch step-by-step guides to get the most out of Cash Canvas.",
    icon: <span role="img" aria-label="Video">🎥</span>,
    to: "https://www.youtube.com/results?search_query=cash+canvas+finance",
    external: true,
  },
  {
    title: "About Us",
    description: "Learn more about our mission, vision, and the team behind Cash Canvas.",
    icon: <span role="img" aria-label="About">ℹ️</span>,
    to: "https://www.mycashcanvas.com/about-us",
    external: true,
  },
  {
    title: "Pricing",
    description: "See our transparent pricing plans and choose what fits you best.",
    icon: <span role="img" aria-label="Pricing">💸</span>,
    to: "https://www.mycashcanvas.com/pricing",
    external: true,
  },
  {
    title: "Blog & Updates",
    description: "Read tips, news, and updates about personal finance and Cash Canvas.",
    icon: <span role="img" aria-label="Blog">📰</span>,
    to: "/blog",
  },
  {
    title: "Terms & Conditions",
    description: "Read our Terms of Service and understand your rights and responsibilities.",
    icon: <span role="img" aria-label="Terms">📋</span>,
    internal: "terms",
  },
  {
    title: "Privacy Policy",
    description: "Learn how we collect, use, and protect your personal information.",
    icon: <span role="img" aria-label="Privacy">🔒</span>,
    internal: "privacy",
  },
];
